import React, { useContext } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { RefreshCw } from 'lucide-react';
import { LanguageProviderContext } from '@/providers/LanguageProvider';
import { isAndroidApp } from '@/utils/platformUtils';
import { useCapacitorUpdateStore } from '@/stores/capacitor/capacitorUpdateStore';
import { applyCapacitorUpdate } from '@/utils/capacitorUpdater';

export const CapacitorUpdateModal: React.FC = () => {
  const languageContext = useContext(LanguageProviderContext);
  const { isOpen, pendingVersion, dismiss } = useCapacitorUpdateStore();

  if (!isAndroidApp() || !languageContext) return null;

  const { translator } = languageContext;

  const handleUpdateNow = async () => {
    await applyCapacitorUpdate();
  };

  const handleLater = () => {
    dismiss();
  };

  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) return;
      }}
    >
      <DialogContent hideCloseButton className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <RefreshCw className="h-5 w-5" />
            {translator('ServiceWorker.updateAvailable')}
          </DialogTitle>
          <DialogDescription>
            {pendingVersion
              ? `${translator('ServiceWorker.updateDescription')} (${pendingVersion})`
              : translator('ServiceWorker.updateDescription')}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:gap-0">
          <Button
            variant="outline"
            onClick={handleLater}
            className="w-full sm:w-auto"
          >
            {translator('ServiceWorker.later')}
          </Button>
          <Button onClick={handleUpdateNow} className="w-full sm:w-auto">
            {translator('ServiceWorker.updateNow')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};